export const SortByIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.88686 13.125C5.94155 13.125 5.4689 14.2422 6.1564 14.8867L11.2697 20C11.6564 20.4297 12.3009 20.4297 12.7306 20L17.8439 14.8867C18.4884 14.2422 18.0158 13.125 17.1134 13.125H6.88686ZM17.8439 8.61328L12.7306 3.5C12.3009 3.11328 11.6564 3.11328 11.2697 3.5L6.1564 8.61328C5.4689 9.30078 5.94155 10.375 6.88686 10.375H17.1134C18.0158 10.375 18.4884 9.30078 17.8439 8.61328Z"
      fill="#292B29"
    />
  </svg>
);
